<template>
    <el-dialog
            :title="title"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
            <!-- <el-button type="primary" v-if="addBtnShow" @click="add()">添加</el-button> -->
            <el-button type="primary" @click="add()">添加</el-button>
            <el-table
                :data="tableList"
                v-loading="tableLoad">
            <el-table-column prop="bblxmc" label="班别名称"></el-table-column>
            <el-table-column prop="bbsbts" label="上班天数" ></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-row>
                        <el-button type="text" @click="update(scope.row)">修改</el-button>
                        <el-button type="text" @click="deleteById(scope.row.id)">删除</el-button>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeBbxx">取消</el-button>
        </span>


        <el-dialog
            :title="dataForm.id ? '修改' : '新增'"
            :close-on-click-modal="false"
            :append-to-body="true"
            :visible.sync="visibleUpdate"
            width="35%">
            <div id="left">
                <el-form ref="dataForm" :model="dataForm" label-width="80px">
                    <el-form-item label="班别名称" prop="bblxmc" :rules="[{ required: true, message: '班别名称不能为空'}]">
                        <el-select clearable filterable @change="selectChanged" v-model="dataForm.bblxmc" placeholder="请选择" :disabled="dataForm.id">
                            <el-option v-for="item in schoolWorkType" :key="item.gzlxdm" :label="item.gzlxmc" :value="item.gzlxmc"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上班天数" prop="bbsbts" >
                        <el-input-number v-model="dataForm.bbsbts"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visibleUpdate = false">取消</el-button>
                <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            return {
                title: '班别信息',
                visible: false,
                tableLoad: false,
                tableList:[],
                visibleUpdate: false,
                dataForm: {},
                queryData: {},
                schoolWorkType: [],
                addBtnShow: false
            }
        },
        methods: {
            init (data) {
                this.title = data.xm + ' -- 班别信息'
                this.queryData = data
                this.visible = true
                this.tableLoad = true
                this.tableList=[]
                this.$request({
                    method: 'post',
                    url: '/bjba/pbgl/getSchoolUserWork',
                    data: data
                }).then((response)=>{
                    this.tableLoad = false
                    // console.log("查询到的学校班别信息为：", response.data)
                    this.tableList = response.data
                    // if (this.tableList.length == 0) {
                    //     this.addBtnShow = true
                    // } else {
                    //     this.addBtnShow = false
                    // }
                }).catch((err)=>{
                    console.log(err)
                    this.tableLoad = false
                });
                this.getSchoolWorkType()
            },
            getSchoolWorkType() {
                this.$request.get('/bjba/pbgl/getSchoolWorkType').then(res => {
                    // console.log("查询返回的数据为：",res.data)
                    this.schoolWorkType = res.data
                })
            },
            add() {
                this.visibleUpdate = true
                this.dataForm = Object.assign({},this.queryData)
                this.dataForm.bbsbts = 1
            },
            update(row) {
                this.dataForm = Object.assign({},row)
                this.visibleUpdate = true
            },
            deleteById(id) {
                this.$confirm(`确定进行[删除]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: '/bjba/pbgl/deleteById',
                        method: 'get',
                        params: {id:id}
                    })
                    .then(response => {
                        this.visibleUpdate = false
                        console.log(response);
                        let data = response.data;
                        if (data.code == 200) {
                            this.$message.success(data.message);
                            this.init(this.queryData);
                        } else {
                            this.$message.error("删除失败！")
                        }
                    })
                    .catch(error => {
                        this.visibleUpdate = false
                        console.log(error)
                        this.$message.error("删除失败！")
                    });
                }).catch(() => {
                })
            },
            dataFormSubmit() {
                // console.log("要提交的表单数据为：",this.dataForm)
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$request({
                            url: this.dataForm.id ? '/bjba/pbgl/update' : '/bjba/pbgl/save',
                            method: 'post',
                            data: this.dataForm
                        })
                        .then(response => {
                            this.visibleUpdate = false
                            console.log(response);
                            let data = response.data;
                            if (data.code == 200) {
                                this.$message.success(data.message);
                                this.init(this.queryData);
                            } else {
                                this.$message.error(data.message)
                            }
                        })
                        .catch(error => {
                            this.visibleUpdate = false
                            console.log(error)
                            this.$message.error("操作失败！")
                        });
                    }
                });
            },
            selectChanged(e) {
                // console.log("选择下拉框获取到的值为：",e)
                this.schoolWorkType.map(res => {
                    if (res.gzlxmc == e) {
                        this.dataForm.bblxdm = res.gzlxdm
                    }
                })
            },
            closeBbxx() {
                this.visible = false
                this.$emit('refreshDataList')
            }
        }
    }
</script>
<style lang="scss" scoped>
    
</style>
